import script from "./PDFViewerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PDFViewerModal.vue?vue&type=script&setup=true&lang=js"

import "./PDFViewerModal.vue?vue&type=style&index=0&id=29c67180&lang=scss"

const __exports__ = script;

export default __exports__